import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "header-menu" }
const _hoisted_2 = { class: "login-menu" }
const _hoisted_3 = {
  key: 0,
  class: "login-mark-div"
}
const _hoisted_4 = { class: "modal-footer-div" }
const _hoisted_5 = { class: "modal-footer-div" }
const _hoisted_6 = { class: "modal-footer-div" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_UserOutlined = _resolveComponent("UserOutlined")!
  const _component_a_avatar = _resolveComponent("a-avatar")!
  const _component_DownOutlined = _resolveComponent("DownOutlined")!
  const _component_a_descriptions_item = _resolveComponent("a-descriptions-item")!
  const _component_sync_outlined = _resolveComponent("sync-outlined")!
  const _component_a_descriptions = _resolveComponent("a-descriptions")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!
  const _component_a_layout_header = _resolveComponent("a-layout-header")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input_password = _resolveComponent("a-input-password")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_layout_header, { class: "header" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_a_menu, {
            theme: "light",
            mode: "horizontal",
            class: "a-menu"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_menu_item, { key: "1" }, {
                default: _withCtx(() => [
                  _createVNode(_component_router_link, { to: "/Home" }, {
                    default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                      _createTextVNode("首页", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_2, [
          (!_ctx.ifLoginIn)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("a", {
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.loginClick && _ctx.loginClick(...args)))
                }, "登录"),
                _cache[18] || (_cache[18] = _createTextVNode(" | ", -1)),
                _createElementVNode("a", {
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.registerClick && _ctx.registerClick(...args)))
                }, "注册")
              ]))
            : _createCommentVNode("", true),
          (_ctx.ifLoginIn)
            ? (_openBlock(), _createBlock(_component_a_dropdown, {
                key: 1,
                class: "userInfo-dropdown"
              }, {
                overlay: _withCtx(() => [
                  _createVNode(_component_a_menu, { class: "userInfo-dropdown-menu" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_descriptions, {
                        layout: "horizontal",
                        size: "small",
                        column: _ctx.descriptionColumn,
                        class: "userInfo-dropdown-menu-descrip",
                        bordered: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_descriptions_item, { label: "用户类型" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.getUserType(_ctx.userInfo.type)), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_descriptions_item, { label: "剩余提问次数" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.userInfo.balance) + "              ", 1),
                              _createVNode(_component_sync_outlined, {
                                onClick: _ctx.userInfoClick,
                                spin: _ctx.userInfoRefresh
                              }, null, 8, ["onClick", "spin"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["column"]),
                      _createVNode(_component_a_menu_item, { style: {"text-align":"center"} }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_popconfirm, {
                            placement: "bottom",
                            "cancel-button-props": {type: 'ghost'},
                            "ok-button-props": {type: 'ghost', danger: true},
                            title: "确认退出登录吗?",
                            "ok-text": "是",
                            "cancel-text": "否",
                            onConfirm: _ctx.logoutClick
                          }, {
                            default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                              _createTextVNode(" 退出登录 ", -1)
                            ]))]),
                            _: 1
                          }, 8, ["onConfirm"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                default: _withCtx(() => [
                  _createElementVNode("a", {
                    class: "ant-dropdown-link",
                    onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"]))
                  }, [
                    _createVNode(_component_a_avatar, { style: {"background-color":"#87d068"} }, {
                      icon: _withCtx(() => [
                        _createVNode(_component_UserOutlined)
                      ]),
                      _: 1
                    }),
                    _createTextVNode(" " + _toDisplayString(_ctx.userInfo.username) + " ", 1),
                    _createVNode(_component_DownOutlined)
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _cache[20] || (_cache[20] = _createTextVNode("    ", -1))
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_a_modal, {
      title: "登录",
      visible: _ctx.loginModalVisible,
      "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.loginModalVisible) = $event)),
      "confirm-loading": _ctx.loginModalLoading,
      onOk: _ctx.loginModalOk
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_a_button, {
            key: "submit",
            type: "primary",
            onClick: _ctx.loginModalOk,
            style: {"width":"30%"}
          }, {
            default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
              _createTextVNode("登录", -1)
            ]))]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          model: _ctx.userInModal,
          "label-col": { span : 2 }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, { label: "邮箱" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.userInModal.email,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.userInModal.email) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "密码" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input_password, {
                  value: _ctx.userInModal.password,
                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.userInModal.password) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createElementVNode("a", {
              style: {"text-align":"center","float":"right"},
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.forgetPasswordHandle && _ctx.forgetPasswordHandle(...args)))
            }, "忘记密码?")
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["visible", "confirm-loading", "onOk"]),
    _createVNode(_component_a_modal, {
      title: "注册",
      visible: _ctx.registerModalVisible,
      "onUpdate:visible": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.registerModalVisible) = $event)),
      "confirm-loading": _ctx.registerModalLoading
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_a_button, {
            key: "submit",
            type: "primary",
            onClick: _ctx.registerModalOk,
            style: {"width":"30%"}
          }, {
            default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
              _createTextVNode("注册", -1)
            ]))]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          model: _ctx.userInModal,
          "label-col": { span : 3 }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              label: "邮箱",
              required: true
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.userInModal.email,
                  "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.userInModal.email) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "密码" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input_password, {
                  value: _ctx.userInModal.password,
                  "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.userInModal.password) = $event))
                }, null, 8, ["value"]),
                _cache[22] || (_cache[22] = _createElementVNode("div", { style: {"font-size":"10px","color":"purple"} }, "至少两种字符, 只能包含数字和英文大小写三种字符, 且长度只在 6 - 16 位 ", -1))
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "验证码" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  style: {"width":"70%"},
                  value: _ctx.userInModal.verifyCode,
                  "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.userInModal.verifyCode) = $event))
                }, null, 8, ["value"]),
                _createVNode(_component_a_button, {
                  disabled: _ctx.verifyBtnDisable,
                  style: {"float":"right","width":"29%"},
                  type: "dashed",
                  onClick: _ctx.sendVerifyCode
                }, {
                  default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                    _createTextVNode(" 发送验证码 ", -1)
                  ]))]),
                  _: 1
                }, 8, ["disabled", "onClick"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "邀请码" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  style: {"width":"100%"},
                  value: _ctx.userInModal.inviteCode,
                  "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.userInModal.inviteCode) = $event)),
                  placeholder: "(选填)"
                }, null, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["visible", "confirm-loading"]),
    _createVNode(_component_a_modal, {
      title: "忘记密码",
      visible: _ctx.forgetModalVisible,
      "onUpdate:visible": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.forgetModalVisible) = $event)),
      "confirm-loading": _ctx.forgetModalLoading
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_a_button, {
            key: "submit",
            type: "primary",
            onClick: _ctx.forgetModalOk,
            style: {"width":"30%"}
          }, {
            default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
              _createTextVNode("OK", -1)
            ]))]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          model: _ctx.userInModal,
          "label-col": { span : 4 }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              label: "邮箱",
              required: true
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.userInModal.email,
                  "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.userInModal.email) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "新密码" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input_password, {
                  value: _ctx.userInModal.password,
                  "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.userInModal.password) = $event))
                }, null, 8, ["value"]),
                _cache[25] || (_cache[25] = _createElementVNode("div", { style: {"font-size":"10px","color":"purple"} }, "至少两种字符, 只能包含数字和英文大小写三种字符, 且长度只在 6 - 16 位 ", -1))
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "重复新密码" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input_password, {
                  value: _ctx.repeatNewPassword,
                  "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.repeatNewPassword) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "验证码" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  style: {"width":"70%"},
                  value: _ctx.userInModal.verifyCode,
                  "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.userInModal.verifyCode) = $event))
                }, null, 8, ["value"]),
                _createVNode(_component_a_button, {
                  disabled: _ctx.verifyBtnDisable,
                  style: {"float":"right","width":"29%"},
                  type: "dashed",
                  onClick: _ctx.sendVerifyCodeForget
                }, {
                  default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                    _createTextVNode(" 发送验证码 ", -1)
                  ]))]),
                  _: 1
                }, 8, ["disabled", "onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["visible", "confirm-loading"])
  ], 64))
}